import { categoryCoverageFor } from '../../../../shared/dishCompatibility.js';
import { RESTRICTION_GROUPS } from '../../../../shared/allergenReference.js';

/**
 * Ce qu'une formule permet, régime par régime — la question que se pose un commercial au téléphone :
 * « est-ce que je peux vendre ce menu à un groupe végétarien ? ».
 *
 * Une formule ne convient à un régime que si CHAQUE catégorie lui laisse au moins un plat : proposer une
 * entrée et un dessert végétariens sans plat ne sert à rien, le convive resterait bloqué au milieu du
 * repas. On distingue donc trois cas, et on ne montre que les deux premiers : afficher les neuf régimes
 * sur chaque carte les rendrait illisibles.
 *
 * Réutilise categoryCoverageFor, la règle qui alimente déjà l'alerte de couverture de l'écran de
 * configuration et ce que le convive voit sur sa page. Un second calcul aurait fini par dire autre chose.
 */
export type DietBadge = { name: string; level: 'ok' | 'adaptable' };

interface DishLike { id: string; category?: string; ingredients?: any[]; dietary_tags?: string[] }

export const formulaDietBadges = (
    structure: { category: string; dish_ids: string[] }[],
    dishById: Map<string, DishLike>,
    allergenTerms: any[] | null,
): DietBadge[] => {
    const filled = structure.filter((row) => row.dish_ids.length > 0);
    // Une formule encore vide ne « convient » à personne : mieux vaut ne rien annoncer que d'annoncer tout.
    if (!filled.length) return [];

    return RESTRICTION_GROUPS.map((group: any) => {
        const profile = { restrictions: [group.name], allergies: [], customTerms: allergenTerms || [] };
        let worst: 'ok' | 'adaptable' | 'aucun' = 'ok';
        for (const row of filled) {
            const dishes = row.dish_ids.map((id) => dishById.get(id)).filter(Boolean);
            const { verdict } = categoryCoverageFor(dishes, profile);
            if (verdict === 'aucun') { worst = 'aucun'; break; }
            if (verdict === 'adaptable') worst = 'adaptable';
        }
        return worst === 'aucun' ? null : { name: group.name, level: worst };
    }).filter(Boolean) as DietBadge[];
};
